import React from 'react';
import { Link } from 'react-router-dom';
import { FaChevronRight } from 'react-icons/fa';

/**
 * 页面标题组件 - 显示页面标题和面包屑导航
 * @param {string} title - 页面标题
 * @param {node} subtitle - 页面副标题或描述
 * @param {array} breadcrumbs - 面包屑导航项 [{path: string, label: string}]
 * @param {node} actions - 页面操作区域(按钮等)
 * @param {string} className - 额外的CSS类名
 */
const PageTitle = ({
  title,
  subtitle,
  breadcrumbs = [],
  actions,
  className = '',
}) => {
  return (
    <div className={`page-title-container mb-4 ${className}`}>
      <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center">
        {/* 标题和副标题 */}
        <div className="mb-3 mb-md-0">
          <h1 className="h3 mb-1">{title}</h1>
          {subtitle && <p className="text-muted mb-0">{subtitle}</p>}
        </div>
        
        {/* 操作区域 */}
        {actions && (
          <div className="page-actions">
            {actions}
          </div>
        )}
      </div>
      
      {/* 面包屑导航 */}
      {breadcrumbs.length > 0 && (
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb mt-3 bg-transparent p-0">
            <li className="breadcrumb-item">
              <Link to="/" className="text-decoration-none">首页</Link>
            </li>
            
            {breadcrumbs.map((item, index) => {
              const isLast = index === breadcrumbs.length - 1;
              
              return (
                <li 
                  key={index}
                  className={`breadcrumb-item d-flex align-items-center ${isLast ? 'active' : ''}`}
                  aria-current={isLast ? 'page' : undefined}
                >
                  {!isLast ? (
                    <>
                      <FaChevronRight className="breadcrumb-separator mx-2" style={{ fontSize: '0.75rem' }} />
                      <Link to={item.path} className="text-decoration-none">
                        {item.label}
                      </Link>
                    </>
                  ) : (
                    <>
                      <FaChevronRight className="breadcrumb-separator mx-2" style={{ fontSize: '0.75rem' }} />
                      <span>{item.label}</span>
                    </>
                  )}
                </li>
              );
            })}
          </ol>
        </nav>
      )}
    </div>
  );
};

export default PageTitle; 